import React from 'react';
import './FreeSparring.css';
import sparringLayout from './images/sparringlayout.webp';
import sparringPoints from './images/sparringpoints.webp';
import { Helmet } from 'react-helmet';

const FreeSparring = () => {
  return (
    <>
      <Helmet>
        <title>TKD Study - Free Sparring</title>
      </Helmet>
      <div className="free-sparring-container">
        <h1 className="banner">Free Sparring <span className="green-bold-title"> (Jayu Matsogi)</span></h1>
        <button className="back-button" onClick={() => window.history.back()}>
          ← Back
        </button>

        <div className="scroll-container">
          <div className="section">
            Free Sparring is open combat with controlled attacking and prohibition of attacking to certain vital spots. In free sparring there is no prearranged mode between the practitioners, with both participants completely free to attack and defend with all available means and methods.
          </div>
          <div className="section center bold">This app covers ITF Sparring Rules</div>

          <div className="section">
            <b>Structure of Sparring:</b>
            <ul>
              <li>Most points wins the round.</li>
              <li>Single Elimination. You must win all your bouts.</li>
              <li>2 rounds of 2 minutes.</li>
              <li>In the event of a draw: 1 round of 1 minute.</li>
              <li>In the event of a second draw: First score wins with no time limit.</li>
            </ul>
          </div>

          <img src={sparringLayout} alt="Sparring Layout" className="image" />

          <div className="section">
            <b>Layout of Sparring:</b>
            <ul>
              <li>10x10 meter square arena.</li>
              <li>4 corner Umpires <b>(U)</b> for score keeping.</li>
              <li>Top table hosts the Jury President who administers the ring.</li>
              <li>Centre Referee <b>(R)</b> is the spokesperson and directs the competitors.</li>
              <li>Red <span className="green-bold">(Hong)</span> is on the right.</li>
              <li>Blue <span className="green-bold">(Chong)</span> is on the left.</li>
            </ul>
          </div>

          <img src={sparringPoints} alt="Sparring Scoring" className="image border" style={{ height: '450px' }} />

          <div className="section">
            <b>Points Scoring:</b>
            <ul>
              <li>One point awarded for any hand attack to mid or high section.</li>
              <li>Two points awarded for any foot attack to mid section.</li>
              <li>Three points awarded for any foot attack to high section.</li>
            </ul>
          </div>

          <div className="horizontal-container">
            <div className="half-section">
              <b><big>Warnings:</big></b>
              <ul>
                <li>Pretending to have scored a point.</li>
                <li>Stepping completely out of the ring.</li>
                <li>Falling down, regardless of how the fall happened.</li>
                <li>Faking an injury, to waste time or fool the opponent.</li>
                <li>Avoiding sparring, running away or facing away from the opponent.</li>
                <li>Attack to an illegal target. Low section or back.</li>
                <li>Pushing with hands, body or shoulders.</li>
              </ul>
            </div>

            <div className="divider" />

            <div className="half-section">
              <b><big>Fouls:</big></b>
              <ul>
                <li>Heavy contact, excessive hard contact will lead to a foul.</li>
                <li>Attacking an opponent on the ground.</li>
                <li>Leg sweeping or any attempt to take the opponent to the ground. Knocking the opponent over does not apply.</li>
                <li>Holding or grabbing of any kind, including unintentional.</li>
                <li>Intentional attack to an illegal target. Low section or back.</li>
              </ul>
            </div>
          </div>

          <div className="section">
            <b><big>Reasons for Disqualifications:</big></b>
            <ul>
              <li>Misconduct against officials.</li>
              <li>Uncontrolled and excessive contact.</li>
              <li>Receive three fouls from the centre referee.</li>
              <li>Being under the influence; including enhancement drugs.</li>
              <li>Loss of temper or self-control.</li>
              <li>Disrespect to opponent, coach or official.</li>
              <li>Use of illegal attacking tools; teeth, nails, knee, elbow or head.</li>
              <li>Causing a knockout; excessive contact.</li>
            </ul>
          </div>

          <div className="ad-placeholder">[Ad Banner Placeholder]</div>
        </div>
      </div>
    </>
  );
};

export default FreeSparring;
